<template>
  <v-autocomplete
    v-bind="$attrs"
    :items="items"
    item-value="id"
    :loading="isSearching"
    :search-input.sync="filter.query"
    v-model="id"
    clearable
    clear-icon="fa-times"
    no-filter
    @keyup="searchKeyUp()"
    @change="searchChanged"
    @click:clear="searchCleared"
  >

    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          Geen klanten gevonden
        </v-list-item-title>
      </v-list-item>
    </template>

    <template v-slot:selection="{ attr, on, item }">
      <span v-text="formatSelectedAddress(item)"></span>
    </template>            

    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="formatAddressTitle(item)"></v-list-item-title>
        <v-list-item-subtitle v-text="formatAddressSubtitle(item)"></v-list-item-subtitle>
      </v-list-item-content>
    </template>

  </v-autocomplete>
  
</template>


<script>
import { inject, watch, ref, getCurrentInstance } from 'vue'
import { debounce } from 'lodash'

export default {
  props: {
    value: [Number, String],
  },
  setup(props) {
    const api = inject('api')
    const { proxy } = getCurrentInstance()

    const id = ref()

    const customerCollection = api.resource('customers').collection({
      rules: {
        query: 'query:contact_name,company_name,address,postcode,city,email,phone_number',
      },
      filter: {
        status: 10,
      },
      itemsPerPage: 20,
    })

    const customerModel = api.resource('customers').model({ debug: true })

    watch(() => props.value, value => {
      if (value) {
        customerModel.find(value).then(() => {
          customerCollection.populate([customerModel.getAttributes()])
          id.value = value
        })
      } else {
        id.value = null
      }
    }, { immediate: true })

    watch(id, value => {
      proxy.$emit('input', value)
    })


    const { items, filter, isSearching } = customerCollection

    const searchKeyUp = debounce(customerCollection.search, 300)

    function searchChanged(item) {
      proxy.$emit('change', item)
    }

    function formatSelectedAddress(item) {
      return (item.name || '') + ', ' + (item.address || '') + ', ' + (item.city || '')
    }

    function formatAddressTitle(item) {
      return (item.name || '') + (item.contact_name ? ' (' + item.contact_name + ')' : '')
    }

    function formatAddressSubtitle(item) {
      return (item.address || '') + ', ' + (item.postcode || '') + ', ' + (item.city || '')
    }

    function searchCleared() {
      customerCollection.populate([])
      proxy.$emit('change')
    }

    return {
      id,
      items,
      filter,
      isSearching,
      searchKeyUp,
      searchChanged,
      searchCleared,

      formatSelectedAddress,
      formatAddressTitle,
      formatAddressSubtitle,
    }

    
  },
}
</script>